import angular from 'angular';

export default angular
	.module('ui.cian.utils.formatNumber', [])
	.directive('cianUtilsFormatNumber', ['$filter', $filter => {
		const formatInput = function(num) {
			if (num) {
				num = $filter('number')(num);
				num = num.replace(',', '.');
			}
			return num;
		};
		return {
			restrict: 'A',
			require: 'ngModel',
			link: (scope, element, attrs, ngModel) => {
				// format initial value
				scope.$evalAsync(() => {
					element.val(formatInput(ngModel.$modelValue));
				});

				element.bind('blur', function() {
					if (ngModel.$valid) {
						element.val(formatInput(ngModel.$modelValue));
					}
				});

				element.bind('focus', function() {
					if (ngModel.$valid) {
						element.val(ngModel.$modelValue);
					}
				});
			}
		};
	}])
	.name;
